import { Component, OnInit } from '@angular/core';
import { OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from '../../../../core/services/auth.service';
import { filter } from 'rxjs/operators';
import { LoadingComponent } from '../../loading/loading.component';

@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [LoadingComponent],
  templateUrl: './callback.component.html'
})
export class CallbackComponent implements OnInit {
  constructor(private readonly _oauthService: OAuthService,
    private readonly _authService: AuthService) {
    this._oauthService.setupAutomaticSilentRefresh();
    this._oauthService.loadDiscoveryDocumentAndTryLogin();
  }

  ngOnInit(): void {
    this._oauthService.events
      .pipe(
        filter((evento: OAuthEvent) => evento.type === 'token_received')
      )
      .subscribe((evento: OAuthEvent) => {
        this._oauthService.loadUserProfile().then((usuario: any) => {
           this._authService.loadUser();
        });
      });
  }
}
